import React, { useState } from "react";
import styles from './quoteRequest.module.css';
import TableComponent from '../../components/OtherComps/TableComponent/TableComponent'
import PartList from "../../components/OtherComps/PartList/PartList";
import { useLocation } from "react-router-dom";

const QuoteRequest = () => {
  const location = useLocation();

  const [productData, setProductData] = useState(() => {
    return location.state?.data
  });

  const deleteProduct = (productNumber) => {
    const filter = productData?.filter((product) => product?.productNumber !== productNumber)
    setProductData(filter)
  }


  return (
    <>
      <div className={styles.imgBread}>
        <span>File Upload Mapping</span>
      </div>

      <div className={styles.fileContainer}>
        <PartList
          data={productData}
          deleteProduct={deleteProduct}
        />
      </div>
    </>
  )
}

export default QuoteRequest